import "jquery-ui/ui/widgets/autocomplete";
import { C } from "../../common/component";
import { Icon, IconHelper } from "../../common/icon-helper";
import { Helper } from "../../common/helper";
import { Dialog } from "../../common/dialog";
import { Requester } from "../../common/requester";
import { Txt } from "../../common/text";
import { EditControl } from "../form-row";

export class TranslatableSuggestionsEditControl implements EditControl
{
    private readonly inputRow: JQuery;
    private readonly inputs: { [code: string]: JQuery } = {};
    private modal;
    private readonly typeData;
    private readonly getRowValue;

    constructor(title: string, languages: { [code: string]: string }, typeData, getRowValue: (rowName: string) => any)
    {
        this.typeData = typeData;
        this.getRowValue = getRowValue;

        this.inputRow = C.div.addClass("ui-front");

        this.inputs["default"] = C.input.addClass("w-form-control").attr("type", "text")

        for (const language in languages)
        {
            this.inputs[language] = C.input.addClass("w-form-control").attr("type", "text");
        }

        const inputGroup = C.div.addClass("w-input-group").appendTo(this.inputRow);
        this.inputs["default"].appendTo(inputGroup);
        const addon = C.span.addClass("w-input-group-addon").appendTo(inputGroup);
        C.span.addClass(IconHelper.getIconClass(Icon.language)).appendTo(addon);

        addon.click(() =>
        {
            if (!this.modal)
            {
                this.modal = new Dialog(title);
                for (const language in languages)
                {
                    const group = C.div.addClass("w-form-group").appendTo(this.modal.body);
                    C.label.text(languages[language]).addClass("control-label").appendTo(group);
                    this.inputs[language].appendTo(group);
                }
                C.button.addClass("w-button-primary main-button").attr("type", "button").text(Txt.close)
                    .click(() => this.modal.hide()).appendTo(this.modal.body);
            }
            this.modal.show();
        });

        this.inputs["default"].autocomplete({
            source: async (request, response) =>
            {
                const params = { search: request.term };
                if (this.typeData.SearchUrl && this.typeData.SearchUrl.Parameters)
                {
                    for (const parameter of this.typeData.SearchUrl.Parameters)
                    {
                        const value = this.getRowValue(parameter.RowName);
                        if (Helper.hasValue(value))
                        {
                            params[parameter.Name] = value;
                        }
                    }
                }
                if (this.typeData.SearchUrl && this.typeData.SearchUrl.Url)
                {
                    response(await Requester.get(this.typeData.SearchUrl.Url, {
                        delay: 250,
                        cache: true,
                        data: params
                    }));
                }
                else
                {
                    response([]);
                }
            },
            minLength: 0
        }).focus(() =>
        {
            if (!Helper.hasValue(this.inputs["default"].val().toString()))
            {
                this.inputs["default"].autocomplete("search");
            }
        });
    }

    initialize(parent: HTMLElement)
    {
        parent.append(this.inputRow[0]);

    }

    async setValue(value: string)
    {
        if (!value)
        {
            for (const language in this.inputs)
            {
                this.inputs[language].val("");
            }
            return;
        }

        try
        {
            const dict = JSON.parse(value);
            for (const language in this.inputs)
            {
                this.inputs[language].val(dict[language] || "");
            }
        }
        catch
        {
            this.inputs["default"].val(value);
            for (const language in this.inputs)
            {
                if (language !== "default")
                {
                    this.inputs[language].val("");
                }
            }
        }
    }

    getValue()
    {
        if (!this.inputs["default"].val())
        {
            return null;
        }
        const result = {};
        for (const language in this.inputs)
        {
            const val = this.inputs[language].val();
            if (val)
            {
                result[language] = val.toString();
            }
        }
        return JSON.stringify(result);
    }

    onChange(action)
    {
        this.inputs["default"].on("input", action);
    }

    focus()
    {
        this.inputs["default"].focus();
    }
}
